import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// RTK Query API definition
export const creditAccountApi = createApi({
  reducerPath: "creditAccountApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_URL}`,
    prepareHeaders: (headers, { getState }) => {
      const { auth } = getState();
      const token = auth.user.token;
      headers.set("Authorization", `Bearer ${token}`);
      headers.set("Content-Type", `application/json;charset=UTF-8`);
      return headers;
    },
  }),
  tagTypes: ["creditAccount"],
  endpoints: (builder) => ({
    getCreditAccountByPaymentType: builder.query({
      query: () => ({
        url: `/Credit/by-payment-type/1001`,
        method: "GET",
      }),
      providesTags: ["creditAccount"],
    }),
    updateCreditAccountStatus: builder.mutation({
      query: (creditAccountData) => ({
        url: `/Credit/updateCreditAccStatus`,
        method: "POST",
        body: creditAccountData,
      }),
      invalidatesTags: ["creditAccount"],
    }),
  }),
});

// Export hooks
export const {
  useGetCreditAccountByPaymentTypeQuery,
  useUpdateCreditAccountStatusMutation,
} = creditAccountApi;

// Direct fetch approach for backwards compatibility
export const getClientsByPaymentType = async (
  paymentTypeID = 1001,
  outletID,
) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/Credit/by-payment-type/${paymentTypeID}?outletID=${outletID}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      },
    );
    const result = await response.json();
    return { status: response.status, data: result };
  } catch (e) {
    console.error("getClientsByPaymentType error", e);
    return { status: 500, message: e.message };
  }
};
